import { scrollPageTo } from '../utils';

export default class ScrollToTop {
	constructor(el) {
		this.scrollToTopButtons = el.querySelectorAll('[data-scroll-to-top]');

		this.scrollToTopButtons.forEach(button => {
			const speed = 1000;
			const target = 0;

			button.addEventListener('click', e => {
				scrollPageTo(target, speed);
			});
		});
	}
}
